<div class="map-draw">
  @if (!isReadOnly()) {
    <div class="map-draw-import">
      <input
        type="file"
        accept=".shp,.zip,.kml"
        (change)="import($event)"
        hidden
        #fileUpload
      />
      <bnd-button
        color="info"
        size="sm"
        class="relative"
        style="z-index: 10"
        (click)="fileUpload.click()"
      >
        {{ 'DIALOG.MAP.IMPORT' | translate }}
      </bnd-button>
    </div>
  }

  <div
    id="map"
    class="map-draw-content"
    #mapcontainer
  ></div>
  @if (!isReadOnly()) {
    <div class="py-3 flex justify-center">
      <bnd-button (click)="cancel.emit()">
        {{ 'DIALOG.BUTTON.CANCEL' | translate }}
      </bnd-button>
      <bnd-button
        class="ml-2"
        color="primary"
        (click)="onButtonOk()"
      >
        {{ 'DIALOG.BUTTON.OK' | translate }}
      </bnd-button>
    </div>
  }
</div>

<ao-confirm-dialog
  [open]="_mapCoreService.confirmDialogOpen()"
  [data]="_mapCoreService.confirmDialogData()"
  (result)="_mapCoreService.onConfirmDialogResult($event)"
/>
